const routes = [{
  path: '/product/platformList',
  component: () => import('@/views/product/platformList'),
  name: 'product/platformList',
  meta: {
    title: '平台产品'
  }
}, {
  path: '/mall',
  component: () => import('@/views/product/mall'),
  name: 'product/mall',
  meta: {
    title: '商城分类'
  }
}, {
  path: '/product/sxProduct',
  component: () => import('@/views/product/sxProduct'),
  name: 'product/sxProduct',
  meta: {
    title: '寿险产品管理'
  }
}, {
  path: '/product/task',
  component: () => import('@/views/product/task'),
  name: 'product/task',
  meta: {
    title: '非车产品管理/任务列表'
  }
}, {
  path: '/authorizationCompany',
  component: () => import('@/views/product/authorizationCompany'),
  name: 'product/authorizationCompany',
  meta: {
    title: '合作保司管理'
  }
}, {
  path: '/nonVehicleInsur',
  component: () => import('@/views/product/nonVehicleInsur'),
  name: 'product/nonVehicleInsur',
  meta: {
    title: '非车保司授权'
  }
}, {
  path: '/nonVehicleProduct',
  component: () => import('@/views/product/nonVehicleProduct'),
  name: 'product/nonVehicleProduct',
  meta: {
    title: '非车产品管理'
  }
}, {
  path: '/plan/book',
  component: () => import('@/views/product/planBook'),
  name: 'planBook',
  meta: {
    title: '计划书管理'
  }
}]
export default routes



// WEBPACK FOOTER //
// ./src/router/product/product.js